import {Card} from 'platform/components';

import {useCallback} from 'react';

import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds, tiresInventoryRoutes} from '@dms/routes';
import {
  DmsDataGrid,
  type DmsDataGridProps,
  Section,
  SectionTab,
  Tires as TiresDG,
  useCustomerUrl,
  usePermissions,
} from '@dms/shared';

import {buildArray, composePath} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

import {CustomerTireSets} from './components/CustomerTireSets';

export function Tires(props: Pick<DmsDataGridProps, 'maximization'>) {
  const [canReadPneuhotel] = usePermissions({permissionKeys: ['pneuhotelRead']});
  const {customerId} = useCustomerUrl();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      customerId,
    }),
    [customerId]
  );

  const tireOrdersActionCallback: ActionCallback = ({actionKey, rowId}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    if (actionKey === 'redirectDetail') {
      const path = composePath(tiresInventoryRoutes.tireOrderDetail, {params: {id}});
      window.open(path, '_blank')?.focus();
    }
  };

  const tabs = buildArray<SectionTab>([])
    .when(canReadPneuhotel, {
      queryId: 'tireOrders',
      content: (
        <Card
          actions={[
            {
              type: 'button',
              variant: 'link',
              leftIcon: 'action/open_in_new',
              title: i18n.t('page.tiresInventory.labels.tiresInventory'),
              onClick: () => window.open(tiresInventoryRoutes.overview, '_blank'),
            },
          ]}
          title={i18n.t('page.tiresInventory.labels.tireOrders')}
        >
          <DmsDataGrid
            maximization={props.maximization}
            autoHeight
            gridCode="customer-tire-order"
            data-testid={testIds.customer.detail('tireOrders')}
            actionCallback={tireOrdersActionCallback}
            queryModifier={queryModifier}
          />
        </Card>
      ),
      title: i18n.t('page.tiresInventory.labels.tireOrders'),
    })
    .when(canReadPneuhotel, {
      queryId: 'tireSets',
      content: <CustomerTireSets maximization={props.maximization} customerId={customerId} />,
      title: i18n.t('page.tiresInventory.labels.tireSets'),
    })
    .when(canReadPneuhotel, {
      queryId: 'tires',
      content: (
        <TiresDG
          maximization={props.maximization}
          customerId={customerId}
          gridCode="customer-tire-list"
        />
      ),
      title: i18n.t('entity.customer.labels.listOfTires'),
    });

  return <Section tabs={tabs} />;
}
